








import Loading from "@/components/common/Loading.vue";
import DialogError from "@/components/common/DialogError.vue";

export default {
  name: "App",
  components: {
    Loading,
    DialogError    
  }
};
